import React, { useEffect  } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Testimonials.css";
import Marquee from "../components/Marquee";

const Testimonials = () => {
  const testimonials = [
    {
      quote: 'I had the privilege of undergoing training at Snow Fountain Civil Engineering Vocational Training Institute (now known as The Civil Lab). The program was highly informative and immensely beneficial for students who have recently completed their diploma or degree.',
      name: 'Abhilash Tiwari',
      role: 'Former Assistant Engineer at CRDF',
    },
    {
      quote: 'I am deeply grateful for the industrial training I received at Snow Fountain Civil Engineering Vocational Training Institute, Lucknow, UP. This hands-on experience laid the foundation for my career, equipping me with the skills and confidence to excel in the construction industry. With over a decade of experience, including six years in urban development and my current role as Construction Manager at IMECO Overseas Pvt Ltd, I owe much of my success to the training, guidance, and industry exposure provided. My heartfelt thanks to the institute, CIDC, and their dedicated team for this invaluable opportunity.',
      name: 'Minhaj Umar Khan',
      role: 'Construction Manager, IMECO Overseas Pvt Ltd',
    },
    {
      quote: 'I am feeling happy to share my experience at Snow Fountain Civil Engineering Vocational Training Institute. I spent a great time of my career during my training here. That training is still helping me in my working career.',
      name: 'Anurag Singh',
      role: 'Assistant Construction Manager at L&T Construction',
    },
    {
      name: "Devesh Mishra",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "All teachers were putting a lot of thought into their lectures and made sure that the course remained engaging and was informative."
    },
    {
      name: "Monish Trivedi",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "This institute does provide practical training in a very clear and precise manner which helped me in understanding the industry requirements and standards."
    },
    {
      name: "Shahbuddin Ahmed",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "It was a privilege to be a part of this institute. The best part about this institute is that their courses are 90% based on practical training so that we can perform well professionally."
    },
    {
      name: "Ajeet Maurya",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "The training session curriculum has the potential to provide exposure to field construction practices. The setup of the organization and its courses has been done in a proficient manner."
    },
    {
      name: "Ashutosh Mishra",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "I gained a lot of knowledge through the course of 40 days. The course material was laid out in such a manner that I was enjoying learning new instruments."
    },
    {
      name: "Kalpana Azad",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "The training session was amazing. All the faculties were also able to explain the concepts in an easy way so that we could grasp them quickly. The content being explained was beneficial to us from an industry perspective."
    },
    {
      name: "Abhishek Shukla",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "Thank you to all the faculties for providing in-depth practical knowledge properly of all the instruments. All faculty members were very friendly and supportive."
    },
    {
      name: "Saurabh Pandey",
      photo:
        "https://i.pinimg.com/736x/51/71/a0/5171a0091726fcd052c80a115b77d580.jpg",
      quote:
        "I am so glad that I enrolled in this training course. It was a great learning experience. I got to learn about so many new instruments and concepts."
    }
  ];

  const companyLogos = [
    "/images/companies/l&t.png",
    "/images/companies/imeco.jfif",
    "/images/companies/crdf.png",
    "/images/companies/repl.jpg",
    "/images/companies/ugcc.jpg",
    "/images/companies/grih-laxmi.png",
    "/images/companies/images.png",
    "/images/companies/shri-balaji-buildcon.png",
    "/images/companies/TUV.jpg",
    "/images/companies/ASL.jpg",
    "/images/companies/adidev.jpeg",
    "/images/companies/PMAY.png",
  ];

  
  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });

    return () => {
      AOS.refresh();
    };
  }, []);

  return (
    <center>
      <div className="testimonials-placement-container">
        {/* Testimonials Section */}
        <div className="testimonials-container" data-aos="fade-up">
        <h1 className="heading">What Our Students Say About Us</h1>
        <div
  className="testimonials-intro"
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "20px",
    flexWrap: "wrap", // Allow items to wrap to the next line
  }}
>
  <div
    className="testimonials-image"
    style={{
      flex: "0 0 50%",
      minWidth: "400px",
      maxWidth: "700px",
    }}
  >
    <img
      src="/images/logo/testimonials.gif"
      alt="Testimonials Logo"
      style={{
        width: "100%",
        maxWidth: "700px",
        minWidth: "300px",
        display: "block", // Ensures proper scaling
        margin: "0 auto", // Center the image horizontally
      }}
    />
  </div>
  <div
    className="testimonials-text"
    style={{
      flex: "0 0 40%",
      minWidth: "300px",
      textAlign: "justify",
      textIndent: "30px",
    }}
  >
    <p>
      At The Civil Lab, we strive to redefine career development by offering
      hands-on training, industry-aligned curricula, and real-world exposure.
      Our programs are meticulously designed to bridge the gap between academic
      learning and professional excellence. By fostering a deep understanding
      of industry practices, we empower our students to not only meet but
      exceed employer expectations.
    </p>
    <p>
      <strong>
        Our mission is simple: to ensure every student is equipped with the
        skills, confidence, and experience to excel in their chosen field from
        the very first day on the job.
      </strong>
    </p>
  </div>
</div>

        <div className="testimonials-grid">
  {testimonials.map((testimonial, index) => (
    <div
      key={index}
      className="testimonial-card"
      data-aos="fade-up"
      data-aos-delay={`${index * 100}`}
      style={{
        position: "relative",
        padding: "20px",
        background: "white", // Default background
        borderRadius: "10px",
        overflow: "hidden",
        transition: "transform 0.3s ease, box-shadow 0.3s ease, background 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "linear-gradient(to bottom, #ffe607, #f8c301)";
        e.currentTarget.style.boxShadow = "0px 10px 20px rgba(0, 0, 0, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "white";
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0px 5px 10px rgba(0, 0, 0, 0.1)";
      }}
    >
      {/* Opening Quote Icon */}
      <i
        className="fa-solid fa-quote-left"
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          fontSize: "100px",
          color: "#f2f2f2",
          opacity: "0.5",
          zIndex: "0",
        }}
      ></i>

      {/* Testimonial Content */}
      <p style={{ zIndex: "1", position: "relative", fontSize: "16px", color: "#333" }}>
        {testimonial.quote}"
      </p>
      <h5 style={{ zIndex: "1", position: "relative", marginTop: "15px", fontWeight: "bold" }}>
        {testimonial.name}
      </h5>
      {testimonial.role && (
        <small style={{ zIndex: "1", position: "relative", color: "#666" }}>
          {testimonial.role}
        </small>
      )}

      {/* Closing Quote Icon */}
      <i
        className="fa-solid fa-quote-right"
        style={{
          position: "absolute",
          bottom: "10px",
          right: "10px",
          fontSize: "100px",
          color: "#f2f2f2",
          opacity: "0.5",
          zIndex: "0",
        }}
      ></i>
    </div>
  ))}
</div>



        </div>
        <div className="placement-container" data-aos="fade-right">
  <h1 className="heading">Placement Success</h1>
  <div
    className="placement-intro"
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: "20px",
      flexWrap: "nowrap", // Prevent wrapping
    }}
  >
    <div
      className="placement-image"
      style={{
        flex: "0 0 40%",
        maxWidth: "40%", // Set consistent max width
        minWidth: "300px", // Ensure a minimum size
        textAlign: "center",
      }}
    >
      <img
        src="/images/logo/placement.gif"
        alt="Placement Logo"
        style={{
          width: "100%",
          maxWidth: "500px", // Limit image size for balance
          minWidth: "200px", // Ensure minimum size
          display: "block",
          margin: "0 auto",
        }}
      />
    </div>
    <div
      className="placement-text"
      style={{
        flex: "1", // Allow the text section to grow if space permits
        maxWidth: "55%", // Limit max width for balance
        minWidth: "300px", // Prevent collapse
        textAlign: "justify",
      }}
    >
      <p>
        At The Civil Lab, our vocational training programs are designed to
        align with the latest trends and advancements in civil engineering. We
        emphasize hands-on learning, exposing students to cutting-edge
        technologies like Building Information Modeling (BIM), advanced
        surveying tools, and modern construction techniques. Our curriculum is
        tailored to meet the evolving needs of the industry, focusing on
        sustainability, smart construction practices, and quality control. This
        ensures our students are equipped with the knowledge and practical
        skills that make them job-ready from day one.
      </p>
      <p>
        Many of our graduates have successfully landed prestigious roles in
        both government and private sectors. From working on critical
        infrastructure projects with public organizations to thriving in
        leading private firms, our students have demonstrated how The Civil
        Lab's training sets them apart. By bridging the gap between academic
        theory and real-world application, we empower our students to
        confidently step into the workforce and excel in their chosen careers.
      </p>
    </div>
  </div>
</div>


        </div>
        {/* Placement Section */}
        <section className="placement-section">
          <h1 className="text-center heading">Our Students Are Placed In</h1><br/><br/>  
          <Marquee companyLogos={companyLogos} />
        </section>
      </center>
  );
};

export default Testimonials;